import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import i18next from '../i18n';


Modal.setAppElement('#root');

const ModalApp = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [newsList, setNewsList] = useState([]);
    
    
    useEffect(() => {
        fetch('/howtodo.json')
            .then(response => response.json())
            .then(data => setNewsList(data))
            .catch(err => console.error('ニュースの取得に失敗しました:', err));
    }, []);
    
    
    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };


    const buttonStyle = {
        display: 'inline-block',
        textDecoration: 'none',
        background: '#668ad8',
        color: '#FFF',
        borderBottom: 'solid 0px #627295',
        fontSize: '15px',
        animation: 'blink 1s infinite',
        fontFamily: 'auto',
        height: '50px',
        width: '151px',
        borderRadius: '50px'
    };

    return (
        <div>
            <button
                
                style={buttonStyle}
                
                
                onClick={openModal}>
                {i18next.t('how')}
            </button>

            <Modal
                isOpen={isModalOpen}
                onRequestClose={closeModal}
                contentLabel="News Modal"
                style={{
                    content: {
                        margin: 'auto',
                        borderRadius: '10px',
                        padding: '20px',
                    },
                    overlay: {
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    },
                }}
            >
                <button onClick={closeModal} style={{ float: 'right' }}>×</button>
                <h2 style={{ textAlign: 'center', fontSize: 29 }}>『  {i18next.t('how')}』</h2>

                <div style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    padding: '20px',
                    boxSizing: 'border-box'
                }}>
                    <div style={{
                        textAlign: 'left',
                        fontSize: '16px',
                        backgroundColor: '#f9f9f9',
                        border: '1px solid #ddd',
                        borderRadius: '10px',
                        padding: '5px',
                        maxWidth: '500px',
                        boxShadow: 'rgb(0 135 255 / 51%) 15px 13px 16px 14px',
                        lineHeight: '1.6',
                        color: '#333'
                    }}>
                        {newsList.map((item, index) => (
                            <div key={index} style={{ marginBottom: '30px', whiteSpace: 'pre-line' }}>
                                <strong>{item.date}</strong><br />
                                {item.content.map((line, i) => (
                                    <p key={i}>{line}</p>
                                ))}
                            </div>
                        ))}
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default ModalApp;
